import { useEffect, useState } from "react";
import { pollJobResult } from "../utils/videoEditor/util";

export type HandleProcess = (
  timeline: any[],
  sourceUrl: string,
  logoPosition: { x: number; y: number },
  logoSizePx: number
) => Promise<void>;

export function useVideoProcessing(logoUrl: string) {
  const [loading, setLoading] = useState(false);
  const [resultUrl, setResultUrl] = useState("");

  useEffect(() => {
    if (resultUrl) {
      const input = document.getElementById("result_url_input");
      if (input) (input as HTMLInputElement).value = resultUrl;
    }
  }, [resultUrl]);

  const handleProcess: HandleProcess = async (
    timeline,
    sourceUrl,
    logoPosition,
    logoSizePx
  ) => {
    setLoading(true);
    setResultUrl("");
    try {
      const formatted = timeline.filter((seg) => seg.speed !== "cut");

      const response = await fetch(
        "https://ns3258217.ip-51-75-216.eu/video-editor",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            videoUrl: sourceUrl,
            segments: formatted,
            logoUrl,
            logoPosition,
            logoSize: logoSizePx,
          }),
        }
      );

      const data = await response.json();
      if (!data.jobId) throw new Error("No jobId returned");

      // Poll until the job completes and we get back a Cloudinary URL
      await pollJobResult(
        data.jobId,
        (cloudinaryUrl: string) => setResultUrl(cloudinaryUrl),
        { delay: 3000, maxTries: 200 }
      );
    } catch (e: any) {
      alert("Erreur: " + (e.message || e));
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    resultUrl,
    handleProcess,
    setResultUrl, // expose if you need to reset the URL from outside
  };
}